module.exports = __webpack_public_path__ + "img/lambda_logo_with_name.1dd10fb8.jpg";